import { useEffect, useState } from "react";

/** Tiny matchMedia hook – `useMediaQuery("(min-width: 1280px)")`. */
export const useMediaQuery = (q) => {
  const [m, setM] = useState(() => (typeof window !== "undefined" && window.matchMedia ? window.matchMedia(q).matches : false));
  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return undefined;
    const mq = window.matchMedia(q);
    const h = (e) => setM(e.matches);
    mq.addEventListener("change", h);
    setM(mq.matches);
    return () => mq.removeEventListener("change", h);
  }, [q]);
  return m;
};
